<template>
  <v-row no-gutters>
    <v-col
      cols="12"
      sm="6"
    >
      <p :class="textPropertyClass">
        <b>Order ID :</b>
        {{ orderDetail.orderId }}
      </p>
      <p :class="`${textPropertyClass} d-flex align-center`">
        <b>Channel</b>
        <v-select
          v-model="orderChannel"
          :items="orderChannels"
          :readonly="orderDetail.currentState !== 'prepare_create'"
          class="expire-date-text-field channel-select-field mx-2"
          dense
          hide-details />
      </p>
      <p :class="textPropertyClass">
        <b>Link : </b>
        <a
          :href="`${billUrl}/th/${orderDetail.url}`"
          target="_blank">{{ orderDetail.url }}</a>
      </p>
      <p :class="textPropertyClass">
        <b>Regen From : </b>
        <span> {{ orderDetail.regenFrom && orderDetail.regenFrom.orderId ? orderDetail.regenFrom.orderId : '-' }}</span>
      </p>
      <div
        v-if="isB2BChannel"
        :class="`d-flex align-center ${lineGap}`">
        <p :class="`${fontType} mb-0 text-no-wrap`">
          <b>Export Shipment</b>
          <b> :</b>
        </p>
        <!-- ตอนสร้าง / Edit ทั้ง order ค่าจะถูกส่งไปพร้อม create / update order -->
        <v-text-field
          v-if="editMode"
          :value="orderDetail.exportShipment"
          :error="isInvalidExportShipment(orderDetail.exportShipment)"
          class="expire-date-text-field export-shipment-field mx-2"
          placeholder="Sheet URL / gid"
          autocomplete="off"
          dense
          hide-details
          @paste="onPasteExportShipment($event, setExportShipment)"
          @input="setExportShipment($event)"
          @change="onChangeExportShipment($event)" />
        <template v-else-if="isEditExportShipment">
          <v-text-field
            v-model="exportShipmentInput"
            :error="isInvalidExportShipment(exportShipmentInput)"
            class="expire-date-text-field export-shipment-field mx-2"
            :disabled="savingExportShipment"
            placeholder="Sheet URL / gid"
            autocomplete="off"
            autofocus
            dense
            hide-details
            @paste="onPasteExportShipment($event, setExportShipmentInput)"
            @keydown.enter="saveExportShipment()" />
          <v-btn
            :loading="savingExportShipment"
            icon
            x-small
            @click="saveExportShipment()">
            <v-icon x-small>
              mdi-check
            </v-icon>
          </v-btn>
          <v-btn
            :disabled="savingExportShipment"
            icon
            x-small
            @click="cancelEditExportShipment()">
            <v-icon x-small>
              mdi-close
            </v-icon>
          </v-btn>
        </template>
        <template v-else>
          <span :class="`${fontType} mx-2`">
            {{ orderDetail.exportShipment || '-' }}
          </span>
          <v-btn
            v-if="isMainOrder"
            icon
            x-small
            @click="editExportShipment()">
            <v-icon x-small>
              mdi-square-edit-outline
            </v-icon>
          </v-btn>
        </template>
      </div>
    </v-col>
    <v-col
      cols="12"
      sm="6">
      <p :class="textPropertyClass">
        <b>Date :</b>
        {{ orderCreateTime }}
      </p>
      <div
        :class="`d-flex align-center ${lineGap}`">
        <p :class="`${fontType} mb-0`">
          <b>Expired Date :</b>
        </p>
        <v-dialog
          ref="modalDate"
          v-model="modalDate"
          :disabled="!editMode"
          persistent
          width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="expireDateText"
              class="expire-date-text-field"
              dense
              readonly
              hide-details
              v-bind="attrs"
              v-on="on">
              <template v-slot:prepend-inner>
                <v-icon small>
                  mdi-calendar
                </v-icon>
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="expireDate"
            :min="minDate"
            scrollable>
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="setModalDate(false)">
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="setModalDate(false)">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </div>
      <p
        :class="`${textPropertyClass} d-flex align-center`"
      >
        <b>Brand : </b>
        <v-select
          v-model="orderBrand"
          :items="brands"
          :readonly="brandSelectable"
          class="expire-date-text-field brand-select-field mx-2"
          dense
          hide-details />
      </p>
      <p :class="`${textPropertyClass} d-flex flex:-row flex-wrap`">
        <b>Tags :</b>
        <v-chip
          v-for="(tag, i) in orderDetail.tags"
          :key="i"
          class="ma-1"
          x-small
          color="orange"
          dark
        >
          {{ tag | toCapitalize() }}
        </v-chip>
      </p>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProductAttributeProvider from '@/resources/ProductAttributeProvider'
import OrderProvider from '@/resources/OrderProvider'
import { extractExportShipmentGid } from '@/assets/js/DefaultOrderData'

const ProductAttributeService = new ProductAttributeProvider()
const OrderService = new OrderProvider()
export default {
    props: {
    fontType: {
      type: String,
      default: 'text-caption'
    },
    lineGap: {
      type: String,
      default: 'mb-0'
    }
  },
  data () {
    return {
      modalDate: false,
      orderChannels: [
        { value: 'manual', text: 'MANUAL' },
        { value: 'celeb', text: 'CELEB' },
        { value: 'international_manual', text: 'INTERNATIONAL MANUAL' },
        { value: 'tiktok', text: 'TIKTOK' },
        { value: 'lazada', text: 'LAZADA' },
        { value: 'b2b_thb', text: 'B2B (THB)' },
        { value: 'b2b_usd', text: 'B2B (USD)' }
      ],
      brands: [],
      isEditExportShipment: false,
      exportShipmentInput: '',
      savingExportShipment: false
    }
  },
  computed: {
    ...mapGetters({
      orderDetail: 'Order/orderDetail',
      editMode: 'Order/onEditMode',
      isMainOrder: 'Order/isMainOrder',
      billUrl: 'Store/linkBill'
    }),
    isB2BChannel () {
      return ['b2b_thb', 'b2b_usd'].includes(this.orderDetail.channel)
    },
    expireDate: {
      get () {
        if (this.orderDetail?.expire) {
          return this.$dayjs(this.orderDetail.expire).format('YYYY-MM-DD')
        }
        return null
      },
      set (newValue) {
        this.actionExpireDate(newValue)
      }
    },
    expireDateText () {
      if (this.orderDetail?.expire) {
        return this.$dayjs(this.orderDetail.expire).format('DD MMM YYYY HH:mm:ss')
      }
      return ''
    },
    minDate () {
      return this.$dayjs().add(1, 'd').format('YYYY-MM-DD')
    },
    orderCreateTime () {
      if (this.orderDetail.createdAt) {
        return this.$dayjs(this.orderDetail.createdAt).format('DD MMM YYYY HH:mm:ss')
      }
      return ''
    },
    currentStatus () {
      return this.orderDetail.status
    },
    orderChannel: {
      get () {
        const { channel } = this.orderDetail
        const allChannels = this.orderChannels.map((orderChannel) => orderChannel.value)
        if (!allChannels[channel]) {
          this.addMoreChannelInSelect({ value: channel, text: `${channel.toUpperCase()}` })
        }
        return this.orderDetail.channel
      },
      set (value) {
        this.setOrderDetailChannel(value)

        if (value === 'b2b_thb' || value === 'b2b_usd') {
          this.expireDate = this.$dayjs().add(30, 'd').format('YYYY-MM-DD')
        } else {
          this.expireDate = this.$dayjs().add(1, 'd').format('YYYY-MM-DD')
        }
      }
    },
    orderBrand: {
      get () {
        return this.orderDetail.brand
      },
      set (value) {
        this.setOrderDetailBrand(value)
      }
    },
    orderShipment () {
      return this.orderDetail?.shipping?.method.toUpperCase() || ''
    },
    brandSelectable () {
      return this.orderDetail.currentState !== 'edit' && this.orderDetail.currentState !== 'prepare_create'
    },
    textPropertyClass () {
      return `${this.fontType} ${this.lineGap}`
    }
  },
  watch: {
    'orderDetail.orderId': {
      handler () {
        this.isEditExportShipment = false
      }
    }
  },
  async mounted () {
    await this.getBrand()
  },
  methods: {
    ...mapActions({
      setExpireDate: 'Order/setExpireDate',
      setOrderDetailChannel: 'Order/setOrderDetailChannel',
      setOrderDetailBrand: 'Order/setOrderDetailBrand',
      setExportShipment: 'Order/setExportShipment',
      setSnackbar: 'Components/setSnackbar'
    }),
    isInvalidExportShipment (value) {
      return !!value?.trim() && !extractExportShipmentGid(value)
    },
    onPasteExportShipment (event, setValue) {
      // วาง URL ของ Google Sheet → ตัดเหลือเฉพาะ gid แทนค่าเดิมทั้งช่อง
      const gid = extractExportShipmentGid(event.clipboardData?.getData('text'))

      if (gid) {
        event.preventDefault()
        setValue(gid)
      }
    },
    onChangeExportShipment (value) {
      // กรณีพิมพ์ URL เอง ตัดเหลือ gid ตอนออกจากช่อง
      const gid = extractExportShipmentGid(value)

      if (gid && gid !== value) {
        this.setExportShipment(gid)
      }
    },
    setExportShipmentInput (value) {
      this.exportShipmentInput = value
    },
    editExportShipment () {
      this.exportShipmentInput = this.orderDetail.exportShipment || ''
      this.isEditExportShipment = true
    },
    cancelEditExportShipment () {
      this.isEditExportShipment = false
    },
    async saveExportShipment () {
      // แก้เฉพาะ exportShipment ผ่าน API แยก ไม่ต้องกด Edit ทั้ง order
      const input = this.exportShipmentInput?.trim() || ''
      const exportShipment = extractExportShipmentGid(input)

      if (!exportShipment) {
        // order เก่าที่ยังไม่เคยมีค่า ปล่อยว่างได้ (ไม่ต้องเรียก API) แต่ถ้าเคยมีค่าแล้วห้ามลบทิ้ง
        if (!input && !this.orderDetail.exportShipment) {
          this.isEditExportShipment = false
          return
        }

        this.setSnackbar({
          value: true,
          message: input ? 'Export Shipment must be a Google Sheet URL with gid or a gid number.' : 'Please fill Export Shipment.',
          type: 'error'
        })
        return
      }

      try {
        this.savingExportShipment = true
        await OrderService.updateExportShipment(this.orderDetail.orderId, exportShipment)
        this.setExportShipment(exportShipment)
        this.isEditExportShipment = false

        this.setSnackbar({
          value: true,
          message: 'Export shipment saved',
          type: 'success'
        })
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `Error code: ${error.code}, ${error.message}`,
          type: 'error'
        })
      } finally {
        this.savingExportShipment = false
      }
    },
    async getBrand () {
      try {
        const { data } = await ProductAttributeService.getProductAttribute('brands', {
          limit: 999
        })

        this.brands = data.results.map((brand) => brand.name)
      } catch (error) {
        console.error('getAttribute: ', error)
      }
    },
    addMoreChannelInSelect (channel) {
      this.orderChannels = ([...this.orderChannels, channel])
    },
    setModalDate (value = false) {
      this.modalDate = value
    },
    actionExpireDate (date = this.$dayjs().add(1, 'd').format('YYYY-MM-DD')) {
      const newDate = this.$dayjs(date).hour(23)
                      .minute(59)
                      .second(59)
                      .millisecond(999)
                      .toISOString()
      this.setExpireDate(newDate)
    }
  }
}
</script>

<style lang="scss">
#order-modal {
  .v-input.expire-date-text-field.v-text-field {
    margin-top: 0;
    input {
      padding: 0;
    }
  }
  .status-dot {
    margin-left: 12px;
  }
  .channel-select-field {
    max-width: 158px;
    div.v-select__slot {
      max-height: 20px;
    }
  }
  .brand-select-field {
    max-width: 158px;
    div.v-select__slot {
      max-height: 20px;
    }
  }
  .export-shipment-field {
    max-width: 158px;
  }
}

</style>
